"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CabecalhoExtranet = void 0;
var react_1 = __importDefault(require("react"));
var estiloCabecalhoExtranet = require("./CabecalhoExtranet.module.scss");
var Cores_1 = require("../Cores/Cores");
var Titulo_1 = require("../Tipografia/Titulo/Titulo");
var CardUsuario_1 = require("../CardUsuario/CardUsuario");
var LogoMicroUniverso_1 = require("../LogoMicroUniverso/LogoMicroUniverso");
var Botao_1 = require("../Botao/Botao");
var Icone_1 = require("../Icone/Icone");
var Notificacao_1 = require("../Notificacao/Notificacao");
var CabecalhoExtranet = function (_a) {
    var titulo = _a.titulo, informacoesUsuario = _a.informacoesUsuario, imagemEmpresa = _a.imagemEmpresa, _b = _a.desabilitarNotificacoes, desabilitarNotificacoes = _b === void 0 ? false : _b, notificacaoProps = _a.notificacaoProps, onLogout = _a.onLogout, onClickNotificacao = _a.onClickNotificacao;
    var renderLogo = (react_1.default.createElement("div", { className: estiloCabecalhoExtranet.logo },
        react_1.default.createElement(LogoMicroUniverso_1.LogoMicroUniverso, { tipoLogo: "LogoIconeMU", Altura: "2rem", Largura: "2rem" })));
    var renderTitulo = (react_1.default.createElement("div", { className: estiloCabecalhoExtranet.titulo },
        react_1.default.createElement(Titulo_1.Titulo, { tag: "h2", cor: Cores_1.Cores.TextoPadrao.CinzaMU600, negrito: true, tipo: "cabecalho2" }, titulo)));
    var renderContentUsuario = (react_1.default.createElement("div", { className: estiloCabecalhoExtranet.contentUsuario },
        notificacaoProps && desabilitarNotificacoes && (react_1.default.createElement(Notificacao_1.Notificacao, __assign({}, notificacaoProps),
            react_1.default.createElement(Botao_1.Botao, { estilo: "text", tamanho: "small", style: { cursor: "pointer" }, tipo: "tipoIconRound", exibirBotaoArrendondado: true, onClick: onClickNotificacao, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU100 },
                react_1.default.createElement(Icone_1.Icone, { nome: "notifications", cor: Cores_1.Cores.GradacaoPrimaria.AzulMU500 })))),
        react_1.default.createElement(CardUsuario_1.CardUsuario, { usuario: informacoesUsuario, onLogout: onLogout })));
    return (react_1.default.createElement("div", { className: estiloCabecalhoExtranet.container },
        react_1.default.createElement("div", { className: estiloCabecalhoExtranet.containerLeft },
            renderLogo,
            renderTitulo),
        renderContentUsuario));
};
exports.CabecalhoExtranet = CabecalhoExtranet;
